module.exports = __webpack_public_path__ + "static/img/password_bg.304ccb2a.png";